<template>
  <div class="meeting-roles f-w f-h">
    <FiltersZone no-options-button>
      <template v-slot:buttons>
        <button
          class="filters-zone__button generic-border generic-border--small-text-btn"
          @click.stop="randomRoles"
        >
          <Icon>{{ random }}</Icon>
          <span>{{ $t('message.ROLES_RANDOM') }}</span>
        </button>
      </template>
    </FiltersZone>
    <div class="meeting-roles__roles f-h-below-filters">
      <div class="roles-list">
        <div
          v-for="(role, index) in roles"
          :key="role.id"
          class="v-centerer f-w roles-row"
        >
          <div
            :id="roleIdRef + index"
            class="role-icon role-icon--drag"
            :class="{selected: role == selectedRole}"
            :style="'background-color:' + (role.assigned ? assignedRoleColor : role.color)"
            @click.stop.self="selectRole($event, role)"
          >
            <Icon
              class="f-h"
              @click.native="selectRoleFromImg($event, role)"
            >
              {{ role.src }}
            </Icon>
          </div>
          <div class="role-details">
            <div class="title">
              {{ role.title }}
            </diV>
            <EllipsisDiv
              :key="`definitionKey${index}-${definitionKey}`"
              class="def"
              :text="role.definition"
              @click.native="App.showIA"
            />
          </div>
        </div>
      </div>
      <div ref="usersList" class="users-list">
        <div
          v-for="(user, index) in users"
          :key="user.id"
          class="v-centerer f-w roles-row"
        >
          <UserThumbnail
            v-model="user.id"
            :all-users="users"
            :disabled="true"
            :fetch-data="true"
          />
          <div class="user-name">
            {{ decodeHTML($t('fullNameFormat', user)) }}
          </div>

          <div class="users-placeholder">
            <div :id="userIdRef + index" @click="assignRoleTo($event, index)">
              <div
                v-if="user.role != null"
                :id="roleIdRef + (user.role.id - 1) + userIdRef + index"
                :ref="`userRole${index}`"
                class="role-icon role-icon--dragback"
                :style="{ 'background-color': user.role.color }"
              >
                <Icon class="f-h">
                  {{ user.role.src }}
                </Icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Page accessible during a meeting.
 * Allows a user to link a meeting participant to a role.
 */


import cloneDeep from 'lodash/cloneDeep';
import $ from 'jquery';
import toastr from 'toastr';
// Import components
import EllipsisDiv from '@/components/ellipsize.vue';
import FiltersZone from '@/components/filters-zone.vue';
import Icon from '@/components/icon.vue';
import UserThumbnail from '@/components/user-thumbnail.vue';
// Import socket handling utils
import mixinSocketHandler from '@/mixins/socket-handler.vue';
import SocketMessages from '@/utils/classes/SocketMessages';
// Import Vuex utils
import { FETCH_TEAMS, FETCH_ROLES } from '@/store/action-types';
// Import utils
import { senseiModal } from '@/utils/ai';
import { calert, decodeHTML, getRandomInt } from '@/utils/main';
import { ROLES } from '@/utils/meeting-utils';
// Assets
import { random } from '@/assets/icons';


export default {

  name: 'MeetingRoles',

  components: {
    EllipsisDiv,
    FiltersZone,
    Icon,
    UserThumbnail,
  },

  mixins: [mixinSocketHandler],

  data() {
    return {
      random,
      /** IDs for drag & drop */
      userIdRef: 'userIdRef',
      roleIdRef: 'roleIdRef',
      /** User may either drag & drop or click to select */
      selectedRole: null,
      selectedRoleElt: null,
      /** Visual */
      assignedRoleColor: '#999999',
      roles: ROLES.map(r => ({ ...r, title: this.$t(r.titleTr), definition: this.$t(r.definitionTr) })),
      /** Data */
      alreadyAssigned: [],
      users: [],
      definitionKey: 1,
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.ROLES_ASSIGNEMENT'),
      iaTeachText: this.$t('sensei.ROLES_TEACHER'),
      iaTeachBtns: [this.teacherBtn('ROLES')],
    };
  },

  computed: {
    meeting() {
      return this.$store.state.meeting.meetingData;
    },
    companyUsers() {
      return this.$store.getters.companyUsers;
    },
    participants() {
      if (this.users.length === 0) return [];
      return this.meeting.participants
        .filter(p => p.attended == 1)
        .map(p => this.users.find(u => u.id == p.user));
    },
    /** Boolean: Is the current account spectator of the meeting */
    isMeetingSpectator() {
      return this.$store.state.meeting.isMeetingSpectator;
    },
  },

  watch: {
    meeting() {
      this.refresh();
    },
  },

  created() {
    this.refresh();
    this.handleSocketMessage(SocketMessages.CC_MSGS.MEETING_ROLES, () => { this.refresh(); });
    $(window).on(`resizeEnd.${this.uuid}`, () => { this.definitionKey++; });
  },

  methods: {
    decodeHTML,
    refresh() {
      if (!this.meeting) {
        return;
      }
      this.$store.dispatch(FETCH_TEAMS)
        .then(() => {
          this.users = this.meeting.participants
            .filter(p => !!this.companyUsers[String(p.user)] && Number(p.attended) === 1)
            .map((p) => {
              const u = cloneDeep(this.companyUsers[String(p.user)]);
              return Object.assign(u, { role: null, id: Number(u.id) });
            });
          // If roles already set
          this.$http.post(
            '/server/meetings/getRoles.php',
            { meeting: this.$store.state.meeting.meetingData.id },
          ).then((response) => {
            if (response.data && Array.isArray(response.data)) {
              // Reset assigned roles
              for (let i = 0; i < this.roles.length; i += 1) {
                this.roles[i].assigned = false;
              }
              this.alreadyAssigned = response.data;
              this.$nextTick(this.setupDragDrop);
            }
          });
        });
    },
    selectRoleFromImg(evt, role) {
      this.selectRole({ target: evt.target.parentNode }, role);
    },
    selectRole(evt, role) {
      if (!this.isMeetingSpectator && !role.assigned) {
        this.selectedRole = role;
        this.selectedRoleElt = evt.target;
      }
    },
    assignRoleTo(evt, userIndex) {
      const user = this.users[userIndex];
      if (this.selectedRole && (!user.role || user.role == null)) {
        const role = this.selectedRole;
        const roleIndex = this.roles.indexOf(role);
        const $el = $(`#${this.roleIdRef}${roleIndex}`);
        if ($el.hasClass('ui-draggable')) {
          $el.draggable('disable');
        }
        role.assigned = true;
        user.role = this.selectedRole;
        this.$nextTick(() => {
          this.setDragBack(userIndex);
        });
        this.doAssignment(role, user);
      }
      this.selectedRole = null;
    },
    /**
     * Assign a role to a user
     * @param {Object} role - Role data contained in this.roles
     * @param {Object} user - User data contained in this.users
     */
    assignRoleToUser(role, user) {
      if (!user.role) {
        const userIndex = this.users.indexOf(user);
        const roleIndex = this.roles.indexOf(role);
        if (userIndex === -1 || roleIndex === -1) {
          return;
        }
        const $el = $(`#${this.roleIdRef}${roleIndex}`);
        if ($el.hasClass('ui-draggable')) {
          $el.draggable('disable');
        }
        role.assigned = true;
        role.userIndex = userIndex;
        user.role = role;
        this.$nextTick(() => {
          this.setDragBack(userIndex);
        });
        this.doAssignment(role, user);
      }
    },
    /**
     * Will remove all assigned roles
     */
    clearRoles(next) {
      this.App.post('/server/meetings/assignRole.php', { meeting: this.meeting.id, clearRoles: true }, (d) => {
        this.roles.forEach((role) => {
          role.assigned = false;
        });
        this.users.forEach((user) => {
          user.role = null;
        });
        next();
      });
    },
    /**
     * Give randomly unassigned roles to user with no role
     */
    randomRoles() {
      const users = this.participants.filter(user => user.role === null);
      const roles = this.roles.filter(role => !role.assigned);
      // Ask for reroll if all users or roles are already assigned
      if (roles.length === 0 || users.length === 0) {
        calert(this.$t('message.ROLES_REROLL'), [
          {
            title: this.$t('message.OK'),
            action: () => {
              this.clearRoles(this.randomRoles);
            },
          },
          { title: this.$t('message.CANCEL') },
        ]);
        return;
      }
      // Assign all unassigned users and roles randomly
      for (let i = 0, len = Math.min(users.length, roles.length); i < len; i += 1) {
        const userIndex = getRandomInt(users.length);
        this.assignRoleToUser(roles[i], users[userIndex]);
        users.splice(userIndex, 1);
      }
    },
    doAssignment(role, user, fromUser, silent) {
      const params = {
        meeting: this.meeting.id,
        user: user.id,
        role: role.id,
        fromUser: fromUser || 0,
      };
      this.App.post('/server/meetings/assignRole.php', params, (d) => {
        if (d == '1') {
          if (!silent) {
            toastr.success(this.$t('message.ROLE_ASSIGNED'));
          }
          this.$store.dispatch(FETCH_ROLES, { meeting: this.$store.state.meeting.meetingData.id });
          this.sendSocketMessage(SocketMessages.CC_MSGS.MEETING_ROLES);
          this.sendSocketMessage(SocketMessages.MT_MSGS.ROLES_UPDATE);
        } else if (!silent) {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    setupDragDrop() {
      if (this.isMeetingSpectator) {
        this.setupAlreadyAssigned();
        return;
      }
      // Drop to assign
      $('.meeting-roles .users-placeholder > div').droppable({
        accept: '.role-icon',
        drop: (e, ui) => {
          const fromOtherUser = $(ui.draggable).hasClass('role-icon--dragback');
          let roleId;
          const dragId = ui.draggable.attr('id');
          if (fromOtherUser) {
            // Switch role between users
            roleId = dragId.split(this.userIdRef)[0];
          } else {
            // Affect role to new user
            roleId = dragId;
          }
          const userId = e.target.id;
          const userIndex = userId.split(this.userIdRef)[1];
          const user = this.users[userIndex];
          const roleIndex = roleId.split(this.roleIdRef)[1];
          const role = this.roles[roleIndex];
          // User already has a role
          if (user.role && user.role != null) {
            return;
          }
          // Assign
          role.assigned = true;
          user.role = role;
          this.$nextTick(() => {
            this.setDragBack(userIndex);
          });
          this.doAssignment(role, user,
            fromOtherUser && !isNaN(role.userIndex)
              ? this.users[role.userIndex].id
              : false);
          if (fromOtherUser) {
            if (!isNaN(role.userIndex)) {
              this.users[role.userIndex].role = null;
            }
          } else {
            $(ui.draggable).draggable('disable');
          }
          role.userIndex = userIndex;
        },
      });
      // Drag to assign
      $('.role-icon--drag').draggable({
        addClasses: false,
        revert: 'invalid',
        refreshPositions: true,
        distance: 20,
        start: (e, ui) => {
          this.selectedRole = null;
          $(this).removeClass('selected');
          $(ui.helper).removeClass('selected');
          $(ui.helper)
            .css('width', `${e.currentTarget.clientWidth}px`)
            .css('height', `${e.currentTarget.clientHeight}px`);
        },
        helper: (e, ui) => {
          const clone = $(e.currentTarget).clone();
          clone.addClass('ui-draggable-dragging');
          $(this.$refs.usersList).append(clone);
          return clone;
        },
      });
      // Drag back to roles zone (unassign)
      $('.meeting-roles .roles-list').droppable({
        accept: '.role-icon--dragback',
        drop: (e, ui) => {
          const dragId = ui.draggable.attr('id');
          const arr = dragId.split(this.userIdRef);
          const roleIndex = arr[0].split(this.roleIdRef)[1];
          const userIndex = arr[1];
          const role = this.roles[roleIndex];
          const user = this.users[userIndex];
          role.assigned = false;
          user.role = null;
          $(`#${this.roleIdRef}${roleIndex}`).draggable('enable');
          this.doAssignment({ id: 0 }, user);
        },
      });
      this.setupAlreadyAssigned();
    },
    /** If some roles are already defined, visually set them up */
    setupAlreadyAssigned() {
      const d = this.alreadyAssigned;
      const comp = this;
      const rolesLength = comp.roles.length;
      const usersLength = comp.users.length;
      let role;
      let roleIndex;
      for (let i = 0, len = d.length; i < len; i++) {
        const o = d[i];
        if (o.role != null && o.user != 0) {
          for (let j = 0; j < rolesLength; j++) {
            if (o.role == comp.roles[j].id) {
              role = comp.roles[j];
              roleIndex = j;
              break;
            }
          }

          for (let j = 0; j < usersLength; j++) {
            if (o.user == comp.users[j].id) {
              const user = comp.users[j];
              const userIndex = j;
              user.role = role;
              role.userIndex = j;
              role.assigned = true;
              if (!this.isMeetingSpectator) {
                this.$nextTick(() => {
                  this.setDragBack(userIndex);
                });
                $(`#${comp.roleIdRef}${roleIndex}`).draggable('disable');
              }
              break;
            }
          }
        }
      }
    },
    /** Create a draggable element to allow dragging the role icon back to the roles container */
    setDragBack(userIndex) {
      const elt = this.$refs[`userRole${userIndex}`];
      $(elt).draggable({
        helper: 'clone',
        revert: 'invalid',
        start(e, ui) {
          $(ui.helper)
            .css('width', `${this.clientWidth}px`)
            .css('height', `${this.clientHeight}px`);
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/vars.scss';

.meeting-roles {
  $role-icon-size: 50px;

  &__roles {
    position: relative;
    padding-top: $page-content-padding;
  }

  /** SECTIONS */
  .users-list,
  .roles-list {
    height: calc(100% - #{$page-content-padding});
    box-sizing: border-box;
    overflow: auto;
    vertical-align: top;
  }

  .roles-row {
    background-color: white;
    box-sizing: border-box;
    padding: 1.5rem;
    border-bottom: 1px solid $color-background-grey;

    & .user-thumbnail__avatar {
      width: 3.5em;
      height: 3.5em;
    }

    &:first-of-type {
      border-top-left-radius: $main-border-radius;
      border-top-right-radius: $main-border-radius;
    }

    &:last-of-type {
      border-bottom-left-radius: $main-border-radius;
      border-bottom-right-radius: $main-border-radius;
      border-bottom: none;
    }
  }

  .users-list {
    width: 100%;
    padding-right: 70%;
    position: relative;
  }

  .users-list .user-name {
    overflow: hidden;
    margin: 0px 20px;
    text-overflow: ellipsis;
  }

  .roles-list {
    width: 65%;
    position: absolute;
    top: $page-content-padding;
    right: $page-content-padding;
  }

  .roles-list.ui-droppable-active > .roles-row {
    background: #{$color-shizen-blue-btn}30;
  }

  /** ROLE ICONS */
  .role-icon {
    // z-index is needed here to enable draggable icon
    z-index: 1;
    $role-img-size: 30px;
    align-items: center;
    box-sizing: border-box;
    border-radius: $main-border-radius;
    display: flex;
    height: $role-icon-size;
    justify-content: center;
    padding: #{($role-icon-size - $role-img-size) / 2};
    width: $role-icon-size;

    > svg {
      color: white;
    }

    &.selected {
      border: 3px solid $color-shizen-blue-btn;
    }

    &--drag {
      min-width: $role-icon-size;
    }

    &.ui-draggable-dragging {
      z-index: 1;
    }
  }
  /** USERS PLACEHOLDER */
  .users-placeholder {
    margin-left: auto;
    text-align: right;

    > div {
      border-radius: $main-border-radius;
      box-sizing: border-box;
      height: $role-icon-size;
      width: $role-icon-size;
      background: $color-gray-background;

      .role-icon {
        height: 100%;
        width: 100%;
      }

      &.ui-droppable-active {
        background-color: #{$color-shizen-blue-btn}30;
      }
    }
  }
  /** ROLE DETAILS */
  .role-details {
    white-space: normal;
    margin-left: 20px;

    .title {
      font-size: 1.1em;
    }

    .def {
      font-size: 0.9em;
      line-height: 1.4em;
      max-height: 4.2em;
      cursor: pointer;
    }
  }
}

@media (max-width: $smartphone-landscape) {
  .meeting-roles {
    .users-list {
      padding-right: 50%;
    }
    .roles-list {
      width: 40%;
    }
  }
}

@media (max-width: $smartphone-portrait) {
  .meeting-roles {
    .users-list {
      padding-right: 100px;
      max-width: none;

      .user-name {
        margin: 0px 5px;
      }
    }
    .roles-list {
      max-width: none;
      padding: 0 5px;
      width: auto;
    }
    .role-details {
      display: none;
    }
  }
}

@media (max-height: 560px) {
  .meeting-roles {
    .roles-row {
      padding: 1em;
    }
  }
}

@media (max-height: 480px) {
  .meeting-roles {
    $role-icon-size: 32px;

    .roles-row {
      height: 40px;
      padding: 2em 1em;
      & .user-thumbnail__avatar {
        width: 2.5em;
        height: 2.5em;
      }
    }
    .role-details .def {
      display: none;
    }
    .role-icon {
      $role-img-size: 18px;
      padding: #{($role-icon-size - $role-img-size) / 2};
      height: $role-icon-size;
      width: $role-icon-size;

      &.selected {
        border-width: 3px;
      }
      &--drag {
        min-width: $role-icon-size;
      }
    }
    .users-placeholder > div {
      height: $role-icon-size;
      width: $role-icon-size;
    }
  }
}
</style>
